import GradeService from "@/services/GradeProdutoService";
import helper from "@/helper";

export const actions = {
  cadastrarGradeProduto: ({ commit, dispatch }) => {
    commit("setGradeProduto", {
      id: "",
      produto_id: "",
      grade_1: "",
      grade_2: "",
      quantidade_estoque: "0,000",
      codigo_barra: "",
      produto_id: "",
    });
    dispatch("setModalCadastroGradeProduto", true);
  },
  listarGradeProduto: ({ commit }, data) => {
    commit("setOverlay", true);
    GradeService.listar(data)
      .then((res) => {
        commit("setGradesProduto", res.data);
        commit("setOverlay", false);
      })
      .catch((e) => {
        console.log(e);
        commit("setOverlay", false);
      });
  },
  visualizarGradeProduto: ({ commit }, data) => {
    // commit("setOverlay", true);
    const grade = {...data, quantidade_estoque: helper.formatQuantidade(parseFloat(data.quantidade_estoque))}
    commit('setGradeProduto', {...grade})
    commit("setModalCadastroGradeProduto", true);

    // GradeService.editar(id)
    //   .then((res) => {
    //     commit("setGradeProduto", res.data);
    //     commit("setOverlay", false);
    //     commit("setModalCadastroGradeProduto", true);
    //   })
    //   .catch((e) => {
    //     console.log(e);
    //     commit("setOverlay", false);
    //   });
  },
  salvarGradeProduto: ({ commit, dispatch, getters }, data) => {
    commit("setModalCadastroGradeProduto", false);
    commit("setOverlay", true);
    GradeService.salvar(data)
      .then((res) => {
        dispatch("listarGradeProduto", {produto_id: getters.getProduto.id });
        commit("setOverlay", false);
        commit("snackbarSuccess", "Grade cadastrada.");
      })
      .catch((e) => {
        console.log(e);
        commit("setOverlay", false);
        commit("snackbarError", "Erro ao cadastrar grade.");
      });
  },
  atualizarGradeProduto: ({ commit, dispatch, getters }, data) => {
    commit("setModalCadastroGradeProduto", false);
    commit("setOverlay", true);
    GradeService.atualizar(data)
      .then((res) => {
        dispatch("listarGradeProduto", {produto_id: getters.getProduto.id });
        commit("setOverlay", false);
        commit("snackbarSuccess", "Grade atualizada.");
      })
      .catch((e) => {
        console.log(e);
        commit("setOverlay", false);
        commit("snackbarError", "Erro ao atualizar grade.");
      });
  },
  excluirGradeProduto: ({ commit, dispatch, getters }, id) => {
    commit("setModalCadastroGradeProduto", false);
    commit("setModalExcluirGradeProduto", false);
    commit("setOverlay", true);
    GradeService.excluir(id)
      .then((res) => {
        dispatch("listarGradeProduto", {produto_id: getters.getProduto.id });
        commit("setOverlay", false);
        commit("snackbarError", "Grade excluída.");
      })
      .catch((e) => {
        console.log(e);
        commit("setOverlay", false);
        commit("snackbarError", "Erro ao excluir grade.");
      });
  },
  setModalCadastroGradeProduto: ({ commit }, status) => {
    commit("setModalCadastroGradeProduto", false);
    setTimeout(() => {
      commit("setModalCadastroGradeProduto", status);
    }, 100);
  },
  setModalExcluirGradeProduto: ({ commit }, status) => {
    commit("setModalExcluirGradeProduto", false);
    setTimeout(() => {
      commit("setModalExcluirGradeProduto", status);
    }, 100);
  },
  setModalListarGradeProduto: ({ commit }, status) => {
    commit("setModalListarGradeProduto", false);
    setTimeout(() => {
      commit("setModalListarGradeProduto", status);
    }, 100);
  },
};

export default {};
